// Version : 0.0.2
// Author :
// LastEdit : VISHAL BHARATHI
// Last ADD : UNNECESSARY PARTS REMOVED
// MODIFIED DATE: 19-09-2025

import WalletReportActionTypes from './wallet-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// FETCH GROUP MEMBER RESPONSE
	fetchGroupMemberResponse: null,
	fetchGroupMemberArr: [],

	// FETCH WALLET RESPONSE
	fetchWalletReportResponse: null,
};

const walletReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START OF FETCH GROUP MEMBER LIST  ******************** */
		case WalletReportActionTypes.FETCH_GROUP_MEMBER_SUCCESS:
			return {
				...state,
				fetchGroupMemberResponse: action.payload,
				fetchGroupMemberArr: docodeHexResponse(action.payload, 'GetGroupMemberListKey'),
			};

		case WalletReportActionTypes.FETCH_GROUP_MEMBER_FAILURE:
			return { ...state, fetchGroupMemberResponse: action.payload };

		case WalletReportActionTypes.FETCH_GROUP_MEMBER_RESPONSE_CHANGED:
			return {
				...state,
				fetchGroupMemberResponse: null,
			};
		/** *********************  END OF FETCH GROUP MEMBER LIST  ******************** */

		/** *********************  START OF FETCH WALLET REPORT  ******************** */
		case WalletReportActionTypes.FETCH_WALLET_REPORT_SUCCESS:
			return {
				...state,
				fetchWalletReportResponse: action.payload,
			};

		case WalletReportActionTypes.FETCH_WALLET_REPORT_FAILURE:
			return { ...state, fetchWalletReportResponse: action.payload };

		case WalletReportActionTypes.FETCH_WALLET_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				fetchWalletReportResponse: null,
			};
		/** *********************  END OF FETCH WALLET REPORT  ******************** */

		default:
			return state;
	}
};

export default walletReportReducer;
